import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import HeaderContent from "./HeaderContent";

import logo from "assets/images/Logo.png";

const Header = ({
  toggleMenu = () => { },
  closeMenu = () => { },
  sidebarDropDown = () => { },
  scrollToSection = () => { },
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 100;

      if (window.scrollY > scrollThreshold) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header
        className={`header ${isSticky ? "sticky" : ""} ${["/profile-setting", "/about-us"]?.includes(location?.pathname)
            ? "header-bg"
            : ""
          }`}
      >
        <nav className="navbar navbar-expand-lg header-nav">
          <div className="navbar-header">
            <button
              id="mobile_btn"
              className="bg-transparent border-0"
              onClick={toggleMenu}
            >
              <span className="bar-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <Link to="/" className="navbar-brand logo">
              <img src={logo} alt="logo" className="img-fluid" />
            </Link>
          </div>
          <div className="main-menu-wrapper">
            <div className="menu-header">
              <Link to="/" className="menu-logo">
                <img src={logo} className="img-fluid" alt="Logo" />
              </Link>
              <button
                id="menu_close"
                className="menu-close bg-transparent border-0"
                onClick={closeMenu}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <ul className="main-nav">
              {HeaderContent?.map((x, i) => {
                return (
                  <li
                    key={i}
                    className="has-submenu ad"
                    onClick={() => scrollToSection(x?.scrollId)}
                  >
                    <Link to={x?.parentPath}>
                      {x?.parentMenu} {x?.parentIcon}
                    </Link>
                    {x?.subParentMenu && (
                      <ul className="submenu">
                        {x?.subParentMenu?.map((y, i) => {
                          return (
                            <li
                              className={`${y?.childMenu ? "has-submenu" : ""}`}
                              key={i}
                            >
                              <Link to={y?.subPath}>{y?.subMenu}</Link>
                              {y?.childMenu && (
                                <ul className="submenu">
                                  {y?.childMenu?.map((child, i) => {
                                    return (
                                      <li key={i}>
                                        <Link to={child?.path}>
                                          {child?.menu}
                                        </Link>
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          <ul className="nav header-navbar-rht reg-head">
            <li>
              <Link to="/register" className="login-btn">
                {/* <img src={regIcon} className="me-1" alt="icon" />  */}
                Pehal Workforce Contributor
              </Link>
            </li>
            <li>
              <Link to="/login" className="login-btn">
                {/* <img src={lockIcon} className="me-1" alt="icon" /> */}
                Pehal Client
              </Link>
            </li>
            {/* <li>
              <a href="post-project.html" className="login-btn">
                Post a Project{" "}
              </a>
            </li> */}
          </ul>
        </nav>
      </header>
    </>
  );
};
export default Header;
